import fetch, { configureFetch } from './lib/fetch';
import * as chat from './chat/';
import * as companion from './chat/companion';
import config from 'config/';

export const MOUNTED = 'app/mounted';
export const USER_AUTHENTICATE = 'app/user-authenticate';
export const USER_AUTHENTICATE_REQUEST = 'app/user-authenticate-request';
export const USER_AUTHENTICATE_FAIL = 'app/user-authenticate-fail';

export const mount = (userTimezoneOffset, embedded = false) => async (dispatch) => {
  configureFetch({ apiRootUrl: embedded ? config.embeddedApiRootUrl : config.apiRootUrl });

  if (config.companionNeeded) {
    await dispatch(companion.mount(reportError));
  }

  //dispatch(checkSchedule());

  return dispatch({ type: MOUNTED,
embedded,
    userTimezoneOffset: userTimezoneOffset || new Date().getTimezoneOffset(),
  });
};

export const startChat = (userTimezoneOffset, clientData, mountFirst = false, embedded = false) => (dispatch) => {
  const isToken = typeof clientData === 'string';

  if (typeof mountFirst === 'boolean' && mountFirst) {
    dispatch(mount(userTimezoneOffset, embedded));
  }
  dispatch({ type: USER_AUTHENTICATE_REQUEST });

  const body = {
    grant_type: isToken ? 'chat_token' : 'password',
    password: isToken ? clientData : '__undefined__',
    userTimezoneOffset,
  };

  if (!isToken) {
    Object.assign(body, clientData);
  }

  return fetch('token', {
    method: 'POST',
    bodyIsForm: true,
    body
  })
    .then((result) => {
      configureFetch({ authorization: `Bearer ${  result.access_token}` });
      dispatch({ type: USER_AUTHENTICATE, token: result.access_token });

      return dispatch(chat.start());
    })
    .catch((error) => {
      reportError({
        message: `Failure retrieving token: ${error.message}, additional information will contain details about the provided info`,
        additionalInformation: body
      });
      return dispatch({ type: USER_AUTHENTICATE_FAIL, error });
    });
};

export const END = 'app/end';
export const end = () => ({ type: END });

export const RESET = 'app/reset';
export const reset = () => ({ type: RESET });

export const reportError = async (error) => {
  let message;

  if (typeof error === 'string') {
    message = error;
  } else if (typeof error.text === 'function' && typeof error.json) {
    message = await error.text();
  } else {
    message = error.message;
  }

  await fetch('log', {
    method: 'POST',
    body: {
      message,
      userAgent: window.navigator.userAgent,
      additionalInformation: typeof error.additionalInformation === 'string'
        ? error.additionalInformation
        : JSON.stringify(error.additionalInformation)
    }
  })
  .then(() => console.log('Reported error'))
  .catch(() => console.warn('Could not report error'));
};

export const IS_OUT_OF_SCHEDULE = 'app/is-out-of-schedule';
export const IS_OUT_OF_SCHEDULE_REQUEST = 'app/is-out-of-schedule-request';
export const IS_OUT_OF_SCHEDULE_FAIL = 'app/is-out-of-schedule-fail';
export const checkSchedule = () => dispatch => {
  dispatch({ type: IS_OUT_OF_SCHEDULE_REQUEST });

  return fetch('schedule/status', { method: 'GET' })
    .then(schedule => dispatch({ type: IS_OUT_OF_SCHEDULE, schedule }))
    .catch(error => console.log(error));
}

export const IS_OUT_OF_SCHEDULE_MESSAGE = 'app/is-out-of-schedule-message';
export const IS_OUT_OF_SCHEDULE_MESSAGE_REQUEST = 'app/is-out-of-schedule-request';
export const IS_OUT_OF_SCHEDULE_MESSAGE_FAIL = 'app/is-out-of-schedule-fail';
export const checkScheduleMessage = () => dispatch => {
  dispatch({ type: IS_OUT_OF_SCHEDULE_MESSAGE_REQUEST });

  return fetch('schedule/msg', { method: 'GET' })
    .then(scheduleMessage => dispatch({ type: IS_OUT_OF_SCHEDULE_MESSAGE, scheduleMessage }))
    .catch(error => dispatch({ type: IS_OUT_OF_SCHEDULE_MESSAGE_FAIL, error }));
}


// WEBPACK FOOTER //
// ./actions/app.js